import { render, staticRenderFns } from "./BaseImageExperimental.vue?vue&type=template&id=672f15fa&"
import script from "./BaseImageExperimental.vue?vue&type=script&lang=ts&"
export * from "./BaseImageExperimental.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports